import bffcli from '../bffcli';

const errorHandler = err => {
  // TODO: Replace and add functionality of logger
  console.log(err);
};

export async function fetchConditionsByTerms(terms) {
  let bodyData = {
    query: terms
  };
  try {
    const conditionResponse = await bffcli.post(
      '/cms/search-condition',
      bodyData
    );
    if (conditionResponse) {
      return conditionResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
}

export async function fetchDrugClassesByTerms(terms) {
  let bodyData = {
    query: terms
  };
  try {
    const conditionResponse = await bffcli.post(
      '/cms/search-drug-class',
      bodyData
    );
    if (conditionResponse) {
      return conditionResponse.data;
    }
  } catch (err) {
    errorHandler(err);
    return err;
  }
}

export async function fetchSymptomsCausesByTerms(terms, type) {
  let bodyData = {
    query: terms,
    conditionType: type
  };
  try {
    return (await bffcli.post('/conditions/search-symptom-cause', bodyData))
      .data;
  } catch (err) {
    errorHandler(err);
    return err;
  }
}
